import s from './input.module.scss';
import {
  InputHTMLAttributes,
  ReactNode,
  useRef,
  useState,
  FocusEvent,
} from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  startAdornment?: ReactNode;
  className?: string;
  placeholder?: string;
  error?: string | boolean;
  helpText?: string;
  type?: string;
  name?: string;
}

export const Input = ({
  placeholder = '',
  startAdornment = null,
  type = 'text',
  className = '',
  name = '',
  error = '',
  ...rest
}: InputProps) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const focusInput = () => {
    inputRef.current?.focus();
  };

  const toggleFocused = () => {
    setFocused((prev) => !prev);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setFocused(false);
    rest?.onBlur && rest.onBlur(e);
  };

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    toggleFocused();
    rest?.onFocus && rest.onFocus(e);
  };

  return (
    <div
      className={clsx(s.fieldWrapper, className, {
        [s.errorField]: Boolean(error),
        [s.withStartAdornment]: startAdornment,
        [s.focused]: focused,
      })}
      onClick={focusInput}
    >
      {startAdornment && (
        <div className={s.startAdornment}>{startAdornment}</div>
      )}
      <input
        className={clsx(s.input, {
          [s.withStartAdornment]: startAdornment,
        })}
        type={type}
        placeholder={placeholder}
        ref={inputRef}
        name={name}
        {...rest}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {error && <p className={s.error}>{error}</p>}
    </div>
  );
};
